import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import { modalActionType } from 'utils/constants';
import Modal from './';
import styled from 'styled-components/macro';
import ReactMarkdown from 'react-markdown';
// @ts-ignore
import markDown from '../../CHANGELOG.md';

const StyledMarkdown = styled.div`
  max-height: 500px;
  overflow-y: auto;
  h2 {
    margin-top: 30px;
    margin-bottom: 30px;
  }
  h3 {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  ul li {
    margin: 0 0 5px 5px;
  }
`;

const ChangeLog = () => {
  const activeModalType = useSelector(selectors.modal.getActionType);
  const modalVisibility = useSelector(selectors.modal.getVisibility);
  const dispatch = useDispatch();
  const [changelog, setChangelog] = React.useState('');

  React.useEffect(() => {
    fetch(markDown)
      .then((res) => res.text())
      .then((text) => setChangelog(text));
  }, []);

  return modalVisibility && activeModalType && activeModalType === modalActionType.CHANGELOG ? (
    <Modal open={modalVisibility} onClose={() => dispatch(actions.modal.closeModal())}>
      <>
        <Modal.Header title="Changelog" subtitle="Lucy4cloud FE" />
        <Modal.Content>
          <StyledMarkdown>
            <ReactMarkdown>{changelog}</ReactMarkdown>
          </StyledMarkdown>
        </Modal.Content>
      </>
    </Modal>
  ) : null;
};

export default ChangeLog;
